import { IonContent, IonItem, IonLabel, IonModal } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

const objectSets = [
    ["🍎", "🍌", "🍇"], ["🚗", "🚌", "🚲"], ["🏀", "⚽", "🏐"],
    ["🐶", "🐱", "🐭"], ["✈️", "🚁", "🚢"], ["🌞", "🌍", "🌊"],
    ["🎈", "🎁", "🎂"], ["🌲", "🌳", "🌿"], ["🏠", "🏢", "🏬"],
    ["📕", "📘", "📗"], ["🐘", "🦓", "🦒"], ["🍔", "🍟", "🥤"],
    ["🚀", "🛰", "🌍"], ["🎤", "🎸", "🥁"], ["🏕", "🔥", "🛶"],
    ["🚴", "🏍", "🚂"], ["🎭", "🎨", "🎬"], ["🦄", "🐉", "🐲"],
    ["🛸", "🛶", "🚤"], ["🦅", "🦆", "🐧"], ["🍓", "🍒", "🍉"],
    ["🐳", "🐬", "🐟"], ["🎯", "🎳", "🎮"], ["⚔️", "🛡", "🏹"],
    ["🔬", "📡", "💡"], ["🌵", "🍀", "🌻"], ["🛵", "🚜", "🚛"],
    ["🦖", "🦕", "🐢"], ["📱", "💻", "🖥"], ["🎺", "🎻", "🥁"],
    ["🧩", "♟", "🎲"], ["📖", "📚", "📰"], ["🌈", "☁️", "🌙"],
    ["🎠", "🎢", "🎡"], ["🍕", "🌮", "🍣"], ["🍩", "🧁", "🍪"],
    ["🥦", "🥕", "🌽"], ["🦜", "🦢", "🦉"], ["🏖", "🏔", "🏜"],
    ["🛳", "🚁", "🚀"], ["🗻", "🏕", "🏝"], ["🛶", "🚤", "⛵"],
    ["🎭", "🎷", "🎺"], ["⚽", "🏈", "🏀"], ["🎹", "🎻", "🎷"],
    ["🦋", "🐞", "🐛"], ["🔑", "🗝", "💰"], ["⚓", "⛵", "🚢"],
    ["🚦", "🚥", "🛑"], ["🏯", "🏰", "🕌"], ["🦊", "🐻", "🐺"],
    ["💎", "📿", "💰"], ["🦎", "🐍", "🐸"], ["🏎", "🚜", "🚛"],
    ["🌼", "🌷", "💐"], ["🎃", "🧛", "👻"], ["🛷", "⛸", "🎿"],
    ["🦆", "🦉", "🦜"], ["🍯", "🍵", "🥛"], ["🧀", "🥖", "🥚"],
    ["🦔", "🐇", "🦨"], ["🛶", "🚤", "🚢"], ["🦜", "🦢", "🦆"],
    ["🚁", "🛫", "🚀"], ["🍎", "🍐", "🍊"], ["🦉", "🐦", "🦜"],
    ["🎂", "🍪", "🧁"], ["🦖", "🦕", "🐢"], ["🧸", "🪀", "🎲"],
    ["📻", "📺", "🎧"], ["🎃", "🎄", "🎁"], ["🥄", "🍴", "🔪"],
    ["💎", "🔮", "⚱"], ["🎩", "👑", "🎓"], ["🌜", "🌞", "🌛"],
    ["🍓", "🍒", "🍉"], ["🚕", "🚙", "🚐"], ["🦁", "🐯", "🐻"],
    ["🎷", "🎸", "🎺"], ["🏅", "🥇", "🥈"], ["📏", "📐", "📎"],
    ["🏡", "🏢", "🏰"], ["🎠", "🎪", "🎢"], ["📷", "🎥", "📽"],
    ["🌵", "🌴", "🎋"], ["🥇", "🥈", "🥉"], ["🍵", "☕", "🥤"],
    ["🛶", "🚤", "⛴"], ["🦌", "🐗", "🐘"], ["🌻", "🌺", "🌼"],
    ["📀", "💽", "💾"], ["🔮", "🪄", "🎩"], ["🥋", "🎽", "🥊"],
    ["🚜", "🚛", "🚚"], ["🎠", "🎢", "🎡"], ["📍", "🧭", "🗺"],
    ["🌞", "🌚", "🌕"], ["🍎", "🍑", "🍏"], ["🚴", "🛹", "🛼"],
    ["🕹", "🎮", "📟"], ["🚁", "🛩", "✈️"], ["🦕", "🦖", "🦣"],
    ["🥑", "🍠", "🥔"], ["📻", "🎧", "📱"], ["🎭", "🎟", "🎬"],
    ["🏆", "🏅", "🥇"], ["📦", "🎁", "🛍"], ["🎸", "🎷", "🎺"],
    ["🎠", "🎡", "🎢"], ["📖", "📚", "📜"], ["🛷", "⛸", "🎿"],
    ["🌄", "🏞", "🗻"], ["📱", "💻", "🖥"], ["🍕", "🍔", "🌭"],
    ["🐠", "🐟", "🐡"], ["📅", "🗓", "📆"], ["📞", "📟", "📠"],
    ["🍚", "🍙", "🍘"], ["📊", "📈", "📉"], ["🎤", "🎧", "📻"],
    ["🚑", "🚒", "🚓"], ["🔬", "🔭", "🧪"], ["🔔", "🎵", "🎶"],
    ["🧩", "🃏", "🎴"], ["🌜", "🌞", "🌛"], ["🍀", "🌹", "🌷"],
    ["🏞", "🏕", "🏔"], ["🏄", "🏊", "🚣"], ["🛒", "🛍", "🎁"],
    ["📯", "🎺", "🎷"], ["📹", "🎥", "📽"], ["🏗", "🏠", "🏢"],
    ["🔑", "🗝", "💰"], ["🦈", "🐋", "🐊"], ["🍵", "☕", "🥤"],
    ["🌵", "🌴", "🎋"], ["🏔", "🗻", "🏞"], ["📞", "📟", "📠"],
    ["🍀", "🌿", "☘"], ["🎖", "🏅", "🥇"], ["🏝", "🏜", "🏞"],
    ["🎠", "🎡", "🎢"], ["🍉", "🍓", "🍇"], ["🎙", "🎤", "🎧"]
];


const BeforeAfter: React.FC = () => {
    const [question, setQuestion] = useState("");
    const [correctAnswer, setCorrectAnswer] = useState("");
    const [message, setMessage] = useState("");
    const [currentObjects, setCurrentObjects] = useState<string[]>([]);
    const [showImage, setShowImage] = useState(false);
    const modal = useRef<HTMLIonModalElement>(null);

    useEffect(() => {
        generateQuestion();
        document.title = "Before, After, Between Worksheets for UKG | Spatial Concepts for Kids";
    }, []);

    const generateQuestion = () => {
        const randomSet = objectSets[Math.floor(Math.random() * objectSets.length)];
        setCurrentObjects(randomSet);

        const randomType = Math.random();
        let newQuestion = "";
        let correct = "";

        if (randomType < 0.33) {
            newQuestion = `Choose the object before ${randomSet[1]}.`;
            correct = randomSet[0];
        } else if (randomType < 0.66) {
            newQuestion = `Choose the object after ${randomSet[1]}.`;
            correct = randomSet[2];
        } else {
            newQuestion = `Choose the object in the between.`;
            correct = randomSet[1];
        }

        setQuestion(newQuestion);
        setCorrectAnswer(correct);
    };

    const checkAnswer = (selected: string) => {
        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion()
                setShowImage(false);
                setMessage("")
            }, 5000)
        } else {
            setShowImage(false);
            setMessage("❌ Oops! Try again.");
        }
    };

    return (
        <>
            <Helmet>
                <meta name="description" content="Teach UKG kids spatial understanding with Before, After, and Between activities. Free printable worksheets to boost observation and logical thinking skills." />
                <link rel="canonical" href="https://mamasguidance.com/ukg/mathematics/pre-math-concepts/before-after-between" />
            </Helmet>
            {
                showImage === false ?
                    <>
                        <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
                            <div className="showInfo" style={{ width: '80%' }} onClick={() => modal.current?.present()}><i className="fas fa-info-circle"></i></div>
                            <IonModal
                                ref={modal}
                                trigger="open-modal"
                                initialBreakpoint={1}
                                breakpoints={[0, 0.5, 0.75, 1]}
                                handleBehavior="cycle"
                                backdropDismiss={false}  // ✅ Prevents click-to-close
                                className="full-page-modal"
                            >
                                <IonContent className="ion-padding">
                                    <div style={{ textAlign: 'right', fontSize: '25px' }} onClick={() => modal.current?.dismiss()}><i className="fas fa-3a fa-times"></i></div>
                                    <h1>Before, After, Between</h1>

                                    <p>
                                        The concepts of <strong>before</strong>, <strong>after</strong>, and <strong>between</strong> are essential for helping UKG learners understand spatial relationships — where things are placed in relation to one another. These are not number-based concepts here but rather <strong>position-based</strong>, which lay the foundation for sequencing, logical thinking, and direction sense.
                                    </p>

                                    <h2>🧠 Why Teach Before, After, and Between?</h2>
                                    <ul>
                                        <li>Builds a sense of order and sequencing</li>
                                        <li>Strengthens logical thinking</li>
                                        <li>Helps children follow directions</li>
                                        <li>Develops vocabulary and sentence formation</li>
                                    </ul>

                                    <p>
                                        For example:
                                        – The cat is <strong>before</strong> the dog.
                                        – The elephant is <strong>after</strong> the monkey.
                                        – The ball is <strong>between</strong> the shoes.
                                    </p>

                                    <h2>🖍️ Activities in the Worksheets</h2>
                                    <ul>
                                        <li>Circle the object that comes <strong>after</strong> the flower</li>
                                        <li>Identify which animal is <strong>before</strong> the lion</li>
                                        <li>Color the object that is <strong>between</strong> two trees</li>
                                        <li>Arrange pictures in before-after-between sequence</li>
                                        <li>Cut-and-paste fun with position cards</li>
                                    </ul>

                                    <h2>👩‍🏫 Teaching Tips for Parents and Teachers</h2>
                                    <ul>
                                        <li>Use real-life examples like lining up toys or placing snacks in order</li>
                                        <li>Ask questions like “What comes after the spoon on the table?”</li>
                                        <li>Read picture books that show sequencing and order</li>
                                        <li>Play “Simon Says” with before/after/between instructions</li>
                                    </ul>


                                    <h2>🔗 Related Topics</h2>
                                    <div>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/long-short"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Long - Short</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/heavy-light"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Heavy - Light</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/front-back"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Front - Back</IonLabel>
                                        </IonItem>
                                    </div>

                                    <h2>🌟 Mama’s Guidance Tip</h2>
                                    <p>
                                        Create a “position walk” with your child — use household items and place them in a row. Then ask fun questions like: <strong>“Which toy is before the truck?”</strong> or <strong>“What comes between the bottle and the spoon?”</strong>
                                    </p>

                                    <div className="btn hero-btn" onClick={() => modal.current?.dismiss()}>Close</div>
                                </IonContent>
                            </IonModal>
                            <article className="visually-hidden">
                                <h1>Before, After, Between</h1>

                                <p>
                                    The concepts of <strong>before</strong>, <strong>after</strong>, and <strong>between</strong> are essential for helping UKG learners understand spatial relationships — where things are placed in relation to one another. These are not number-based concepts here but rather <strong>position-based</strong>, which lay the foundation for sequencing, logical thinking, and direction sense.
                                </p>

                                <h2>🧠 Why Teach Before, After, and Between?</h2>
                                <ul>
                                    <li>Builds a sense of order and sequencing</li>
                                    <li>Strengthens logical thinking</li>
                                    <li>Helps children follow directions</li>
                                    <li>Develops vocabulary and sentence formation</li>
                                </ul>

                                <p>
                                    For example:
                                    – The cat is <strong>before</strong> the dog.
                                    – The elephant is <strong>after</strong> the monkey.
                                    – The ball is <strong>between</strong> the shoes.
                                </p>

                                <h2>🖍️ Activities in the Worksheets</h2>
                                <ul>
                                    <li>Circle the object that comes <strong>after</strong> the flower</li>
                                    <li>Identify which animal is <strong>before</strong> the lion</li>
                                    <li>Color the object that is <strong>between</strong> two trees</li>
                                    <li>Arrange pictures in before-after-between sequence</li>
                                    <li>Cut-and-paste fun with position cards</li>
                                </ul>

                                <h2>👩‍🏫 Teaching Tips for Parents and Teachers</h2>
                                <ul>
                                    <li>Use real-life examples like lining up toys or placing snacks in order</li>
                                    <li>Ask questions like “What comes after the spoon on the table?”</li>
                                    <li>Read picture books that show sequencing and order</li>
                                    <li>Play “Simon Says” with before/after/between instructions</li>
                                </ul>


                                <h2>🔗 Related Topics</h2>
                                <div>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/long-short"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Long - Short</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/heavy-light"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Heavy - Light</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/front-back"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Front - Back</IonLabel>
                                    </IonItem>
                                </div>

                                <h2>🌟 Mama’s Guidance Tip</h2>
                                <p>
                                    Create a “position walk” with your child — use household items and place them in a row. Then ask fun questions like: <strong>“Which toy is before the truck?”</strong> or <strong>“What comes between the bottle and the spoon?”</strong>
                                </p>
                            </article>
                            <h2>{question}</h2>
                            <div className="optionImageDiv" style={{ margin: "20px 0", display: "flex", "flexWrap": "wrap", "gap": "30px" }}>
                                {currentObjects.map((object, index) => (
                                    <div key={index} style={{ cursor: "pointer" }} onClick={() => checkAnswer(object)}>
                                        {object}
                                    </div>
                                ))}
                            </div>
                            <p>{message}</p>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default BeforeAfter;
